export const chf = (n) => `CHF ${Number(n || 0).toFixed(2)}`;

export function statusTone(s) {
  if (s === "pending") return "warning";
  if (s === "cancelled") return "error";
  if (s === "completed" || s === "delivered" || s === "picked_up") return "neutral";
  if (s === "ready" || s === "delivering") return "success";
  return "brand";
}

// Backend stores naive UTC datetimes; parse them as UTC.
function parseUTC(s) {
  if (!s) return null;
  const hasTz = /Z$|[+-]\d\d:\d\d$/.test(s);
  return new Date(hasTz ? s : `${s}Z`);
}

export function fmtTime(s) {
  const d = parseUTC(s);
  if (!d || isNaN(d.getTime())) return "--:--";
  return d.toLocaleTimeString("fr-CH", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Zurich" });
}

export function fmtDate(s) {
  const d = parseUTC(s);
  if (!d || isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("fr-CH", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Zurich" });
}

// 16+ for fermented drinks (beer, wine, prosecco), 18+ for spirits; a mixed selection requires 18+.
export function requiredAge(items) {
  const ages = items.filter((i) => i.is_alcohol).map((i) => (i.alcohol_type === "spirits" ? 18 : 16));
  return ages.length ? Math.max(...ages) : null;
}
